import { useState } from 'react'
import { router } from '@inertiajs/react'

import { csrfToken } from '../../../utils/csrfToken'
import { MoneyInput } from '../../../components/MoneyInput'

export default function New({ errors }) {
  const [name, setName] = useState('')
  const [totalAmount, setTotalAmount] = useState('')
  const [dividendsPercentage, setDividendsPercentage] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState(null)
  const normalizedErrors = errors && Object.keys(errors).length ? errors : null
  const [fieldErrors, setFieldErrors] = useState(normalizedErrors)

  async function submit(e) {
    e.preventDefault()
    setSaving(true)
    setError(null)
    setFieldErrors(null)

    const response = await fetch('/executives/bonuses', {
      method: 'POST',
      headers: {
        'X-CSRF-Token': csrfToken() || '',
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        bonus: { name, total_amount: totalAmount, dividends_percentage: dividendsPercentage },
      }),
      credentials: 'same-origin',
    })

    if (response.status === 302 || response.redirected) {
      router.visit('/executives/bonuses')
      return
    }

    if (response.status === 200 || response.status === 201) {
      router.visit('/executives/bonuses')
      return
    }

    if (response.status === 422) {
      const payload = await response.json()
      const nextErrors = payload.errors && Object.keys(payload.errors).length ? payload.errors : null
      setFieldErrors(nextErrors)
      setError(null)
      setSaving(false)
      return
    }

    setError(`Failed to create bonus: ${response.status}`)
    setSaving(false)
  }

  return (
    <div className="container-fluid">
      <div className="row justify-content-center">
        <div className="col-12 col-lg-10 col-xl-8">
          <div className="mb-4">
            <h1>Create Bonus</h1>
            <button type="button" className="btn btn-link p-0" onClick={() => router.visit('/executives/bonuses')}>
              &lt; Back
            </button>
          </div>

          {error ? <div className="alert alert-danger">{error}</div> : null}
          {fieldErrors ? (
            <div className="alert alert-danger">
              <div>Bonus was not saved</div>
            </div>
          ) : null}

          <form onSubmit={submit}>
            <div className="form-group">
              <label className="form-label" htmlFor="name">
                Name
              </label>
              <input
                id="name"
                type="text"
                className="form-control"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              {fieldErrors?.name ? (
                <div className="invalid-feedback d-block">{fieldErrors.name.join(', ')}</div>
              ) : null}
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="total_amount">
                Total Bonuses to be Distributed
              </label>
              <MoneyInput
                value={totalAmount}
                onChange={setTotalAmount}
                inputClassName="form-control"
              />
              {fieldErrors?.total_amount ? (
                <div className="invalid-feedback d-block">{fieldErrors.total_amount.join(', ')}</div>
              ) : null}
            </div>

            <div className="form-group">
              <label className="form-label" htmlFor="dividends_percentage">
                Dividends Budget (%)
              </label>
              <div className="input-group">
                <input
                  id="dividends_percentage"
                  type="number"
                  step="0.01"
                  min="0"
                  max="100"
                  className="form-control"
                  value={dividendsPercentage}
                  onChange={(e) => setDividendsPercentage(e.target.value)}
                />
                <span className="input-group-text">%</span>
              </div>
              {fieldErrors?.dividends_percentage ? (
                <div className="invalid-feedback d-block">{fieldErrors.dividends_percentage.join(', ')}</div>
              ) : null}
            </div>

            <div className="form-group">
              <button type="submit" className="btn w-100 btn-primary" disabled={saving}>
                {saving ? 'Creating…' : 'Create Bonus'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
